import React, { MouseEvent, useEffect, useState } from 'react'
import ActiveDeactiveDialogConfirmation from 'components/ActiveDeactiveDialogConfirmation'
import { FilterMatchMode } from "primereact/api"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router';
import { handleLoader, handleNotFound } from 'redux/counterSlice';
import { useDispatch, useSelector } from 'react-redux';
import { ToastContent, toast } from 'react-toastify';
import { getNotification, activeInActive, deleteNotifications, currentNotification, getNotificationById, addNotifications, updateNotification } from '../../services/notificationService'
import { Tag } from 'primereact/tag';
import { PERMISSION_DENIED_MESSAGE } from '../../constants/index';
import DeleteNotificationModal from 'components/DeleteNotificationModal';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { datatableDelete, datatableDeleteHover, datatableEdit, datatableEditHover } from 'assets/icons';
import { Sidebar } from 'primereact/sidebar';
import { InputTextarea } from 'primereact/inputtextarea';
import { Calendar } from 'primereact/calendar';
import { Controller, useForm } from 'react-hook-form';
import { formateDate } from 'utils/formatDate';

const Notification = () => {
    const {
        handleSubmit,
        setValue,
        control,
        setError,
        clearErrors,
        formState: { errors },
    } = useForm<any>()
    const permissions = useSelector((state: any) => state.persistent.announcement_permissions);
    const dispatch = useDispatch();
    const [notifications, setNotifications] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState<Record<string, any>>();
    const [deleteItems, setDeleteItems] = useState<{ for_active: boolean, id: [] }>({ for_active: true, "id": [] })
    const [deleteNotification, setDeleteNotification] = useState<{ id: [] }>({ "id": [] })
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [filters, setFilters] = useState<{ [s: string]: any }>();
    const [is_edit, setIs_edit] = useState<string>("");
    const [active, setActive] = useState<boolean>()
    const [first, setFirst] = useState(0); // State to control the first page
    const [sortField, setSortField] = useState(""); // State to control the first page
    const [sortOrder, setSortOrder] = useState<any>(""); // State to control the first page
    const [rowsPerPage, setRowsPerPage] = useState(5); // State to control the rows per page
    const navigate = useNavigate();

    const getNotificationsAll = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getNotification();
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setNotifications(result)
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }
    const handleSort = (event: any) => {
        setSortField(event.sortField)
        setSortOrder(event.sortOrder)
        setFirst(0);  //Move to page 1
        // dispatch(setFirstVoice(0)); // Move to page 1
    };
    const getCurrentNotification = async () => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await currentNotification();
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            localStorage.setItem('announcements', JSON.stringify(result))
            // setNotifications(result)
            // toast.success(result.message)
            dispatch(handleLoader(false));
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }

    const onGlobalFilterChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFirst(0);
        const value = e?.target?.value;
        let _filters = { ...filters };

        _filters['global']!.value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const getSeverity = (status: string) => {
        switch (status) {
            case 'Active':
                return 'success';

            case 'Inactive':
                return 'warning';
        }
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        })
        setGlobalFilterValue("")
    }
    useEffect(() => {
        dispatch(handleNotFound(false))
        const temp = async () => {
            await getCurrentNotification();
            await getNotificationsAll();
        }
        temp();
        initFilters();
        // CustomerService.getCustomersMedium().then((data) => setNotifications(data));
    }, []);

    const onClear = () => {
        setSelectedProducts(undefined);
        setDeleteItems({ for_active: true, "id": [] });
        setActive(false)
    }


    const onDeleteClick = (e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>, { id, is_active }: { id: number, is_active: boolean }) => {
        e.stopPropagation();
        setDeleteItems((prevState: any) => ({ ...prevState, for_active: !is_active, id: [...prevState.id, id], updated_by: localStorage.getItem("username") }))
        setActive(!is_active)
    }

    const deleteNotificationSingle = (e: MouseEvent<HTMLSpanElement, globalThis.MouseEvent>, id: number) => {
        e.stopPropagation();
        setDeleteNotification((prevState: any) => ({ ...prevState, id: [...prevState.id, id], deleted_by: localStorage.getItem("username") }))
    }

    const setDeleteUserList = async (is_active: boolean) => {
        if (selectedProducts?.length > 0) {
            selectedProducts?.forEach((element: any) => {
                setDeleteItems((prevState: any) => ({ ...prevState, for_active: is_active, id: [...prevState.id, element.id], updated_by: localStorage.getItem("username") }))
            });
            setActive(is_active)
        } else {
            toast.error("Please select at least one announcement to update the status", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }
    const setDeleteUserNotifications = async () => {
        if (selectedProducts?.length > 0) {
            selectedProducts?.forEach((element: any) => {
                setDeleteNotification((prevState: any) => ({ ...prevState, id: [...prevState.id, element.id], deleted_by: localStorage.getItem("username") }))
            });
        } else {
            toast.error("Please select at least one announcement to delete", {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const deleteUsers = async () => {
        try {
            const { result, error } = await activeInActive(deleteItems)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            await getCurrentNotification()
            await getNotificationsAll()
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            onClear()
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const deleteMultipleNotifications = async () => {
        try {
            const { result, error } = await deleteNotifications(deleteNotification)
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            await getCurrentNotification()
            await getNotificationsAll()
            toast.success(result.message, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
            onClear()
        } catch (error) {
            toast.error(error as ToastContent<unknown>, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            })
        }
    }

    const handleDate = (rowData: any) => {
        const tempDate = new Date();
        const rowDate = new Date(rowData.end_date)

        tempDate.setHours(0, 0, 0, 0);
        rowDate.setHours(0, 0, 0, 0);
        if (rowDate < tempDate) {
            return <span>{rowData.end_date}</span>
        } else {
            return <span className=''>{rowData.end_date}</span>
        }
    }

    const handleStartDate = (rowData: any) => {
        const tempDate = new Date();
        const rowDate = new Date(rowData.end_date)

        tempDate.setHours(0, 0, 0, 0);
        rowDate.setHours(0, 0, 0, 0);
        if (rowDate < tempDate) {
            return <span>{rowData.start_date}</span>
        } else {
            return <span className=''>{rowData.start_date}</span>
        }
    }

    const [is_hover_Edit, setIs_hover_Edit] = useState<string>("");
    const [is_hover_Delete, setIs_hover_Delete] = useState<string>("");

    const [visible, setVisible] = useState<boolean>(false);
    const customHeader = (
        <div className="flex align-items-center gap-2">
            {is_edit !== "" ? 'Edit' : 'Add'} Announcement
        </div>
    );

    // Add Edit part

    const getAnnouncementById = async (id: any) => {
        dispatch(handleLoader(true));
        try {
            const { result, error } = await getNotificationById(id);
            if (error) {
                throw error
            }
            if (result?.error) {
                throw result.error
            }
            setValue("notification_text", result.notification_text);
            setValue("dates", [new Date(result.start_date), new Date(result.end_date)]);
            setIs_edit(id);
            dispatch(handleLoader(false));
            setVisible(true);
        } catch (error: any) {
            dispatch(handleLoader(false));
            toast.error(error, {
                style: {
                    backgroundColor: '#F1F1F1', // Grey background
                }
            });
        }
    }


    const onSubmit = async (data: any) => {
        if (data.dates && data.dates[0] !== null && data.dates[1] === null) {
            setError('dates', { type: 'custom', message: "Please select end date also", });
        } else {
            data.start_date = formateDate(data.dates[0])
            data.end_date = formateDate(data.dates[1])
            delete data.dates
            dispatch(handleLoader(true));
            if (is_edit === "" && permissions.add) {
                try {
                    data.created_by = localStorage.getItem("username");
                    const { result, error } = await addNotifications(data);
                    if (error) {
                        throw error
                    }
                    if (result?.error) {
                        throw result.error
                    }
                    toast.success(result.message, {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                    setVisible(false);
                    setIs_edit("");
                    await getNotificationsAll();
                    dispatch(handleLoader(false));
                    setValue("notification_text", "");
                    setValue("dates", "");
                    getCurrentNotification()
                } catch (error: any) {
                    dispatch(handleLoader(false));
                    toast.error(error, {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                }
            } else if (is_edit !== "" && permissions.edit) {
                try {
                    data.updated_by = localStorage.getItem("username");
                    data.id = is_edit
                    const { result, error } = await updateNotification(data);
                    if (error) {
                        throw error
                    }
                    if (result?.error) {
                        throw result.error
                    }
                    toast.success(result.message, {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    })
                    setVisible(false);
                    setIs_edit("");
                    await getNotificationsAll();
                    dispatch(handleLoader(false));
                    setValue("notification_text", "");
                    setValue("dates", "");
                    getCurrentNotification();
                } catch (error: any) {
                    dispatch(handleLoader(false));
                    toast.error(error, {
                        style: {
                            backgroundColor: '#F1F1F1', // Grey background
                        }
                    });
                }
            }
        }
    }

    const onCancel = () => {
        setValue("notification_text", "");
        setValue("dates", "");
        setVisible(false);
        setIs_edit("");
        clearErrors();
    }

    return (
        <>
            <div className="datatable-wrapper">
                <div className='p-4 content-wrapper'>
                    <div className="switch-section user-management-section">
                        <div className='d-flex align-items-center justify-content-between flex-wrap mb-3 table-top-row'>
                            <h4 className="mb-0">Announcements</h4>
                            <div className="d-flex justify-content-between align-items-center table-right-row">
                                <div className='d-flex align-items-center table-right-first'>
                                    <div className='d-flex align-items-center table-search mr-3 mt-1 mb-1'>
                                        <IconField iconPosition="right" className='user-input'>
                                            <InputIcon className="pi pi-search"></InputIcon>
                                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Search by announcement" />
                                        </IconField>
                                    </div>
                                    {/* <span className="p-input-icon-left me-sm-2">
                                <i className="pi pi-search" />
                                <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Enter announcement title" />
                            </span> */}
                                    {permissions.add &&
                                        // <Button className='btn btn-primary btn-sm px-3 mt-2 mt-sm-0' disabled={!permissions.add} onClick={async () => {
                                        //     navigate('/admin/announcements/add')
                                        // }}><i className="fa-solid fa-user-plus"></i> Add Announcement</Button>
                                        <Button label="Add Announcement" outlined icon="pi pi-plus" className='outline-icon-btn mr-3 mt-1 mb-1' onClick={() => setVisible(true)} />
                                        // onClick={async () => {
                                        //     navigate('/admin/announcements/add')
                                        // }} 
                                    }
                                </div>
                                {permissions.delete &&
                                    <div className='table-right-end mt-1 mb-1'>
                                        <Button className='outline-icon-btn grey-outline-btn active-btn mr-3' outlined label='Active'
                                            data-bs-toggle={permissions.delete && (selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target={permissions.delete && "#active-deactive"} onClick={() => setDeleteUserList(true)}
                                        ></Button>
                                        <Button className='outline-icon-btn grey-outline-btn inactive-btn mr-3' outlined label='Inactive'
                                            data-bs-toggle={permissions.delete && (selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target={permissions.delete && "#active-deactive"} onClick={() => setDeleteUserList(false)}
                                        ></Button>
                                        <Button className='outline-icon-btn grey-outline-btn delete-btn' outlined label='Delete'
                                            data-bs-toggle={permissions.delete && (selectedProducts && selectedProducts !== null && selectedProducts.length !== 0) && "modal"} data-bs-target={permissions.delete && "#delete-notification"} onClick={() => setDeleteUserNotifications()}
                                        ></Button>
                                    </div>
                                }
                            </div>
                        </div>
                        <DataTable
                            selection={selectedProducts}
                            selectionPageOnly
                            onSelectionChange={(e) => { setSelectedProducts(e.value) }}
                            paginator
                            filters={filters}
                            globalFilterFields={["notification_text", "start_date", "end_date"]}
                            first={first}
                            onPage={(e) => { setFirst(e.first); setRowsPerPage(e.rows) }}
                            rows={rowsPerPage}
                            sortField={sortField}
                            sortOrder={sortOrder}
                            sortMode="single"
                            onSort={handleSort}
                            rowsPerPageOptions={[5, 10, 25]}
                            stripedRows
                            value={notifications}
                            tableStyle={{}}
                            emptyMessage="No notification records found"
                        >
                            {/* <DataTable selection={selectedProducts} onSelectionChange={(e) => { setSelectedProducts(e.value) }} filters={filters} value={notifications} paginator stripedRows rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{}}> */}
                            <Column
                                selectionMode="multiple"
                                headerStyle={{ width: "3rem" }}
                            ></Column>
                            <Column field="notification_text" sortable header="Announcement Text" ></Column>
                            <Column field="start_date" header="Start Date" body={handleStartDate} sortable ></Column>
                            <Column field="end_date" header="End Date" body={handleDate} sortable />
                            <Column field="status" header="Status" showFilterMenu={false} filterMenuStyle={{ width: '14rem' }}
                                body={(rowData) => (<Tag
                                    data-bs-toggle={permissions.delete && "modal"}
                                    data-bs-target={permissions.delete && "#active-deactive"}
                                    onClick={(e) => {
                                        permissions.delete ? onDeleteClick(e, rowData) : toast.error(PERMISSION_DENIED_MESSAGE, {
                                            style: {
                                                backgroundColor: '#F1F1F1', // Grey background
                                            }
                                        })
                                    }}
                                    value={rowData.is_active ? 'Active' : 'Inactive'}
                                    severity={getSeverity(rowData.is_active ? 'Active' : 'Inactive')}
                                    className={rowData.is_active ? 'status-tag active' : 'status-tag inactive'}
                                />)}
                            />
                            <Column header="Action" body={(rowData) => (
                                <div className='d-flex'>
                                    <span onClick={(e) => {
                                        e.stopPropagation(); permissions.edit ? getAnnouncementById(rowData?.id) : toast.error(PERMISSION_DENIED_MESSAGE, {
                                            style: {
                                                backgroundColor: '#F1F1F1', // Grey background
                                            }
                                        })
                                    }} className="mr-3" onMouseEnter={() => setIs_hover_Edit(rowData.id)} onMouseLeave={() => setIs_hover_Edit("")}>
                                        <img src={is_hover_Edit === rowData.id ? datatableEditHover : datatableEdit} alt='edit-icon' />
                                    </span>
                                    <span data-bs-toggle={permissions.delete && "modal"}
                                        data-bs-target={permissions.delete && "#delete-notification"} onClick={(e) => {
                                            permissions.delete ? deleteNotificationSingle(e, rowData.id) : toast.error(PERMISSION_DENIED_MESSAGE, {
                                                style: {
                                                    backgroundColor: '#F1F1F1', // Grey background
                                                }
                                            })
                                        }} onMouseEnter={() => setIs_hover_Delete(rowData.id)} onMouseLeave={() => setIs_hover_Delete("")}>
                                        <img src={is_hover_Delete === rowData.id ? datatableDeleteHover : datatableDelete} alt='edit-icon' />
                                    </span>
                                </div>)}>
                            </Column>
                        </DataTable>
                        <Sidebar position="right" header={customHeader} visible={visible} onHide={onCancel} className='form-sidebar'>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="form-sidebar-body">
                                    <div className='form-row'>
                                        <div className='form-col'>
                                            <label className="form-label">Announcement Message<i>*</i></label>
                                            {/* <InputTextarea placeholder="Announcement Message" /> */}
                                            <Controller
                                                name="notification_text"
                                                control={control}
                                                defaultValue=""
                                                rules={{ required: true }}
                                                render={({ field }) => (
                                                    <InputTextarea
                                                        placeholder='Announcement Message'
                                                        {...field}
                                                        // className={`form-control ${errors.notification_text ? 'is-invalid' : ''
                                                        //     }`}
                                                        maxLength={150}
                                                    // rows={3}
                                                    // cols={60}
                                                    />
                                                )}
                                            />
                                            {errors.notification_text && (<p className="text-danger">{'Announcement message is required'}</p>)}
                                        </div>
                                    </div>
                                    <div className='form-row'>
                                        <div className='form-col'>
                                            <label className="form-label">Date<i>*</i></label>
                                            {/* <Calendar
                                                selectionMode="range"
                                                readOnlyInput
                                                showIcon
                                                hideOnRangeSelection
                                                // className="custom-calendar-icon"
                                                placeholder="Start Date - End Date"
                                            /> */}
                                            <Controller
                                                name="dates" // Specify the field name
                                                control={control}
                                                defaultValue={null} // Set the initial value as needed
                                                rules={{ required: "Date is required" }} // Add validation rules here
                                                render={({ field: { onBlur, onChange, value } }) => (
                                                    <Calendar
                                                        minDate={new Date()}
                                                        value={value}
                                                        onChange={(e) => {
                                                            onChange(e.value)
                                                            clearErrors('dates')
                                                        }}
                                                        selectionMode="range"
                                                        readOnlyInput
                                                        showIcon
                                                        hideOnRangeSelection
                                                        placeholder="Start Date - End Date"
                                                    />
                                                )}
                                            />
                                            {errors.dates && <p className="text-danger">{errors.dates.message as any}</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className='form-sidebar-footer'>
                                    <Button className='grey-outline-btn btn-lg' type='button' onClick={onCancel} label='Cancel'></Button>
                                    <Button className='outline-active-btn btn-lg' type='submit' label='Save'></Button>
                                </div>
                            </form>
                        </Sidebar>
                    </div>
                </div>
            </div>
            <ActiveDeactiveDialogConfirmation active={active!} changeStatus={deleteUsers} onCancel={onClear} />
            <DeleteNotificationModal changeStatus={deleteMultipleNotifications} onCancel={onClear} />
        </>
    )
}

export default Notification